import { StaticImage } from "gatsby-plugin-image"
import React from "react"
export default function Header({ title, image }) {
  return (
    <div className="h-[36rem] overflow-hidden grid">
      <div className="h-[36rem] col-start-1 row-start-1 z-0 relative">
        {!image ? (
          <StaticImage
            alt={title}
            className="h-full w-full object-cover animate"
            src="../../images/An7Mm1FI.png"
          />
        ) : (
          image
        )}
      </div>
      <div className="h-[36rem] col-start-1 row-start-1 relative z-10 bg-gray-800 bg-opacity-50">
        {title && (
          <div className="h-full flex items-end justify-center pb-8">
            <h1 className="text-white text-2xl md:text-5xl">{title}</h1>
          </div>
        )}
      </div>
    </div>
  )
}
